const localeEs = {
  es: {
    MENU_ROUTE_HOME: 'Inicio',
    MENU_ROUTE_HANA_AI: 'Crehana AI',
    MENU_ROUTE_HANA_AI_ASSISTANT: 'Asistente',
  },
};

export default localeEs;
